export default {
  init() {
    const radioButtons = document.querySelectorAll('.form__radio[type="radio"]');
    const paragraph = document.querySelector('#contribution-paragraph');

    radioButtons.forEach(button => {
      button.addEventListener('change', event => {
        const selectedValue = event.target.value;
        if (selectedValue === "2.08") {
          paragraph.textContent = "Deze korting geldt voor de eerste 24 maanden van het lidmaatschap, daarna geldt het reguliere tarief.";
        } else if (selectedValue === "12.50") {
          paragraph.textContent = "Ik betaal het reguliere tarief van €12,50 per maand.";
        }
      });
    });
  }
};
